import { html } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import moment from 'moment';
import nls from '../../locales/index.nls';
import KiStationInfo from './ki-station-info';

export default
@i18n(nls)
class KiStationGWInfo extends KiStationInfo {
  _stationTmpl(station) {
    const dce = this.i18n.t(station.GR_RM_RESDCE);
    return html`<div class="station-name">${station.COMMUNE_LOCALITE} / ${station.ISIN_LOCALITE}</div>
      <hr />
      <div class="table">
        <div class="row">
          <div class="cell label">${this.i18n.t('station_no')}</div>
          <div class="cell">${station.station_no}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('CODESO')}</div>
          <div class="cell">${station.CODESO}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('MASESO_WEB')}</div>
          <div class="cell">${station.MASESO_WEB}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('GR_RM_RESDCE')}</div>
          <div class="cell">${dce}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('last_measure_date')}</div>
          <div class="cell">${(station.timestamp && moment(station.timestamp).format('L')) || '-'}</div>
        </div>
      </div>`;
  }
}

customElements.define('ki-station-gw-info', KiStationGWInfo);
